import { Directive, OnDestroy, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { startWith, Subscription, tap } from 'rxjs';
import { ReadonlyService } from 'src/app/core/services/readonly.service';

@Directive({ selector: '[appReadonly]' })
export class ReadonlyDirective implements OnDestroy {
  containerRef = inject(ViewContainerRef);
  templateRef = inject<TemplateRef<any>>(TemplateRef);
  private isReadonlySvc = inject(ReadonlyService);

  private sub = new Subscription();

  constructor() {
    this.sub.add(
      this.isReadonlySvc
        .getReadonly()
        .pipe(
          startWith(true),
          tap((isReadonly) => {
            if (!isReadonly) {
              this.containerRef.clear();
              this.containerRef.createEmbeddedView(this.templateRef);
            }
          })
        )
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
